import React from 'react';

import { updateToIdsOnServerAction } from 'actions/task';
import styled from 'styled-components';

import { GOAL_EVENTS1, sendGoalEvent } from 'constants/mixpanelHelper';
import { routesForTracking } from 'constants/routesForTracking';

import ToIdsComponent from '../ToIdsComponent';

export default function GoalToIds({
  dispatch,
  goalId,
  goalKey,
  employees,
  padding,
  pageName = null,
  renderEmptyView,
  maxNodes,
  iconSize,
}) {
  function onUpdate(newEmployees) {
    if (pageName) {
      let referrer = 'MeshList';

      switch (pageName) {
        case routesForTracking.home.pageName:
        case routesForTracking.profile.pageName:
          break;

        case routesForTracking.team.pageName:
        case routesForTracking.tagDetail.pageName:
          referrer = 'Card';
      }

      sendGoalEvent({
        page: { pageName, flow: 'Activity' },
        eventName: GOAL_EVENTS1.updated,
        field: 'owners/collaborators',
        referrer,
      });
    }

    dispatch(updateToIdsOnServerAction({ id: goalId, key: goalKey, toIds: newEmployees }));
  }

  return (
    <Container padding={padding}>
      <ToIdsComponent
        employees={employees}
        onUpdate={onUpdate}
        renderEmptyView={renderEmptyView}
        maxNodes={maxNodes}
        iconSize={iconSize}
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: ${(props) => props.padding ?? '10px'};
`;
